import React from 'react'
import { Link } from 'react-router-dom'
const heroImg=`https://raw.githubusercontent.com/wdridoy11/web-icon/fa6c0b85b82dc93303ff4b05d89f407e59b257b5/hero-01.png`;
const socialMedia=[
    {
        id:1,
        title:"facebook",
        icon:`https://raw.githubusercontent.com/wdridoy11/web-icon/5e67dd4525c2540eafbe0609facf015df0c8f14a/facebook%20(1).png`,
        link:"https://web.facebook.com/wdridoy11"
    },
    {
        id:2,
        title:"instagram",
        icon:`https://raw.githubusercontent.com/wdridoy11/web-icon/5e67dd4525c2540eafbe0609facf015df0c8f14a/instagram.png`,
        link:"https://www.instagram.com/wdridoy11"
    },
    {
        id:3,
        title:"linkedin",
        icon:`https://raw.githubusercontent.com/wdridoy11/web-icon/5e67dd4525c2540eafbe0609facf015df0c8f14a/linkedin.png`,
        link:"https://www.linkedin.com/in/wdridoy11"
    },
    {
        id:4,
        title:"behance",
        icon:`https://raw.githubusercontent.com/wdridoy11/web-icon/5e67dd4525c2540eafbe0609facf015df0c8f14a/behance.png`,
        link:"https://www.behance.net/wdridoy11"
    }
]

const Hero = () => {
  return (
    <div>
        <div className="hero min-h-screen" style={{ backgroundImage: `url("https://github.com/wdridoy11/web-icon/blob/main/hero.jpg?raw=true")` }}>
          <div className="hero-overlay bg-opacity-60"></div>
          <div className="hero-content">
            <div className='grid lg:grid-cols-2 items-center justify-center gap-10'>
                <div className='order-last lg:order-first'>
                    <h1 className="mb-3 text-5xl font-medium text-white">Hi!<br/>I'm <span className='text-[#22d3ee]'>Ridoy Sharif</span></h1>
                    <h2 className="mb-5 text-4xl font-bold text-[#22d3ee]">Full Stack Web Developer & WordPress Expert</h2>
                    <p className="mb-2 p-0 lg:pr-10 text-white"> I’m a Full Stack Web Developer & WordPress Expert. I have completed 100+ website.</p>
                    <Link className="btn text-white bg-transparent border-2 border-[#22d3ee] px-10 rounded-full mt-7 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3" to={`https://drive.google.com/uc?id=1atB930Hr_nkufVMAhMbOCnwtXZ_VNYPZ&export=download`}>Resume download</Link>
                    <Link className="btn text-white bg-transparent border-2 border-[#22d3ee] px-10 rounded-full mt-7 hover:bg-[#22d3ee] hover:text-white duration-500" to={'/portfolio'}>My Portfolio</Link>
                    <div className='flex gap-2 mt-7'>
                        {socialMedia.map((social)=> <Link key={social.id} className='w-10 border-2 border-[#22d3ee] rounded-full' to={social.link} target='_blank'><img src={social.icon} alt={social.title} /></Link>)}
                    </div>
                </div>
                <div className='order-first lg:order-last'>
                    <img src={heroImg} alt="hero-img" />
                </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Hero